import React from 'react'
import t from 'prop-types'
import Image from '../Images/Image'

const Avatar = ({
  bio,
  image,
  isSmall,
  name,
  role,
  publishedDate,
  publishedDateTime,
}) => {
  return (
    <>
      <div className="flex items-center">
        {image && (
          <Image
            className={`${isSmall ? 'w-16' : 'w-24'} rounded-full`}
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
          />
        )}
        <div className={image && `ml-4`}>
          <div>
            {name && (
              <p
                className={`${
                  isSmall ? 'text-base inline' : 'text-lg'
                } text-gray-700`}
              >
                {name}
                {isSmall && role ? ', ' : ''}
              </p>
            )}
            {role && (
              <p
                className={`text-base ${
                  isSmall ? 'inline text-gray-700' : 'text-gray-500'
                }`}
              >
                {role}
              </p>
            )}
          </div>
          {publishedDate && (
            <div className="text-sm text-gray-500">
              <time datetime={publishedDateTime}>{publishedDate}</time>
            </div>
          )}
        </div>
      </div>
      {bio && !isSmall && (
        <p className="text-base md:text-lg mt-4 text-gray-700 font-regular">
          {bio}
        </p>
      )}
    </>
  )
}

Avatar.propTypes = {
  bio: t.string,
  img: t.string,
  isSmall: t.bool,
  name: t.string,
  publishedDate: t.string,
  publishedDateTime: t.string,
  role: t.string,
}

Avatar.defaultProps = {}

export default Avatar
